import ReactLoading from 'react-loading';

const LoadingView = ({ color }) => {
    return (
        <div>
            <div
                style={{
                    width: "100%",
                    height: "100",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <ReactLoading type={"spinningBubbles"} height={80} width={80} color={color} />
            </div>
        </div>
    )
}

export default LoadingView;
